import './add_services.css';
import React, { useEffect, useState } from 'react';
import { Row, InputGroup } from 'react-bootstrap';
import Form from 'react-bootstrap/Form'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import swal from 'sweetalert';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import Backdrop from '@mui/material/Backdrop';
import FormControlLabel from '@mui/material/FormControlLabel';
import CircularProgress from '@mui/material/CircularProgress';
import Checkbox from '@mui/material/Checkbox';
import { create_service, get_all_departments } from '../../../services/company_admin_service';
import { get_active_habilitations } from '../../../services/habilitations service';

function Add_services() {

    let user = JSON.parse(localStorage.getItem('user-info'));

    //////form inputs
    const [first_name, setFirst_name] = useState('');
    const [last_name, setLast_name] = useState('');
    const [email, setEmail] = useState('');
    const [role, setRole] = useState('null');
    const [habilitation, setHabilitation] = useState('null');
    const [department, setDepartment] = useState("");
    const [is_manager, setis_manager] = useState(false);


    const [cnss, setcnss] = useState("");
    const [country, setcountry] = useState("");
    const [city, setcity] = useState("");
    const [address, setaddress] = useState("");
    const [postcode, setpostcode] = useState("");
    const [tele, setTele] = useState("");

    const [departments, setDepartments] = useState([]);
    const [available_habilitations, setavailable_habilitations] = useState([]);

    const [wait_submitting, setWait_submitting] = useState(false);
    const [errorText, setErrorText] = useState(null);

    const [signature_file, setSignature_file] = useState(null);
    const [notify_user, setnotify_user] = useState(false);


    useEffect(() => {
        async function load_data() {
            await get_all_departments().then((response) => {
                setDepartments(response.data);
            }).catch((error) => {
               //  console.log(error.response);
            });

            await get_active_habilitations().then((response) => {
                setavailable_habilitations(response.data);
               //  console.log(response.data);
            }).catch((error) => {
               //  console.log(error.response);
            })
        }
        load_data();
    }, [])

    //////////////////////////////
    /////////////email validation
    function invalid_email_pattern(email) {
        var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
        if (email !== "") {
            if (!pattern.test(email)) {
                return true;
            } else {
                return false;
            }
        } else return true;
    }

    ////////////////////////////

    /////////////////////////////
    /////////////////////////////Submit
    function submit() {
       //  console.log(department);
        setErrorText(null);
        //|| country === "" || city === "" || address === "" || postcode === "" || tele === ""
        if (email === "" || last_name === "" || first_name === "" || role === "null" || habilitation === "null" || department === "") {
            setErrorText("Champs invalides !");
        } else {
            if (invalid_email_pattern(email)) {
                setErrorText("Email invalid !");
            } else {
                swal({
                    title: "Etes-vous sûr ?",
                    text: "!!!",
                    icon: "warning",
                    buttons: true,
                    dangerMode: true,
                })
                    .then(async (willDelete) => {
                        if (willDelete) {
                            setWait_submitting(true);
                            let formData = new FormData();
                            formData.append('fullName', last_name + " " + first_name);
                            formData.append('email', email);
                            formData.append('country', country);
                            formData.append('cnss', cnss);
                            formData.append('city', city);
                            formData.append('address', address);
                            formData.append('postcode', postcode);
                            formData.append('phoneNumber', tele);
                            formData.append('role', role);  
                            formData.append('habilitation', habilitation);
                            formData.append('department', department);
                            formData.append('is_manager', is_manager ? 1 : 0);
                            formData.append('notify_user', notify_user ? 1 : 0);
                            formData.append('signature_file', signature_file);
                            await create_service(formData).then((response) => {
                                setWait_submitting(false);
                                setFirst_name('');
                                setLast_name('');
                                setEmail('');
                                setRole('null');
                                setHabilitation('null');
                                setcnss('');
                                setcountry('');
                                setcity('');
                                setaddress('');
                                setpostcode('');
                                setTele('');
                                swal("Le service a été ajoutée avec succès !" + (response.data.mdp ? "\n Mot de passe : " + response.data.mdp : ""), {
                                    icon: "success",
                                    buttons: true,
                                }).then((willDelete) => {
                                    if (willDelete) {
                                    }
                                })
                            }).catch((error) => {
                                //console.log(error.response);
                                let error_data = error.response.data;
                                if (error_data.message) {
                                    if (error_data.message.includes("email")) setErrorText("Email déjà existant !");
                                    if (error_data.message.includes("phone")) setErrorText("Téléphone déjà existant !");
                                }
                                setWait_submitting(false);
                            });
                        }
                    })
            }
        }

    }

    async function upload_user_signature(file) {
        setSignature_file(file);
    }


    ///////////////////////////////////////
    ///////////////////////////////////////

    return (
        <div className="add_services_form">
            <h2>Nouveau service</h2>
            <div className="form" >
                {
                    <p className={errorText ? "col-md-12 error" : "col-md-12 valid-champ"}>
                        {errorText}
                    </p>
                }
                <Row className="mb-12">
                    <Form.Group className="col-md-6">
                        <label>Nom *</label>
                        <Form.Control
                            required
                            autoComplete="new-password"
                            type="text"
                            placeholder="Nom *"
                            value={last_name}
                            onChange={e => { setLast_name(e.target.value) }}
                            className={errorText && last_name === "" ? "is-invalid" : ""}
                        />
                    </Form.Group>

                    <Form.Group className="col-md-6">
                        <label>Prénom *</label>
                        <Form.Control
                            required
                            autoComplete="new-password"
                            type="text"
                            placeholder="Prénom *"
                            value={first_name}
                            onChange={e => { setFirst_name(e.target.value) }}
                            className={errorText && first_name === "" ? "is-invalid" : ""}
                        />
                    </Form.Group>


                    <Form.Group className="col-md-6">
                        <label>Email *</label>
                        <InputGroup hasValidation>
                            <Form.Control
                                required
                                autoComplete="new-password"
                                type="text"
                                placeholder="E-mail *"
                                value={email}
                                onChange={e => { setEmail(e.target.value); }}
                                className={errorText && invalid_email_pattern(email) ? "is-invalid" : ""}
                            />
                            <InputGroup.Text className={errorText && invalid_email_pattern(email) ? "invalid-inputgroup" : "valid-inputgroup"}>
                                <FontAwesomeIcon icon={faEnvelope} />
                            </InputGroup.Text>
                        </InputGroup>
                    </Form.Group>


                    <Form.Group className="col-md-6">
                        <label>Rôle *</label>
                        <Form.Select
                            required
                            value={role}
                            onChange={e => {
                                setRole(e.target.value);
                            }}
                            className={errorText && role === "null" ? "is-invalid" : ""}
                            name="categorie"
                        >
                            <option value={"null"} disabled selected>Rôle</option>
                            <option value={1}>{"service d'achat"}</option>
                            <option value={2}>{"service métier"}</option>
                            <option value={3}>{"service de finance"}</option>
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="col-md-6">
                        <label>Habilitation *</label>
                        <Form.Select
                            required
                            value={habilitation}
                            onChange={e => {
                                setHabilitation(e.target.value);
                            }}
                            className={errorText && role === "null" ? "is-invalid" : ""}
                            name="habilitation"
                        >
                            <option value={"null"} disabled selected>Habilitation</option>
                            {
                                available_habilitations.map((hab) => (
                                    <option key={"habil_" + hab.id} value={hab.id}>{hab.role_title}</option>
                                ))
                            }
                        </Form.Select>
                    </Form.Group>


                    <Form.Group className="col-md-6">
                        <label>Département *</label>
                        <Form.Select
                            value={department}
                            onChange={e => {
                                setDepartment(e.target.value);
                            }}
                            className={(errorText && department == "" ? "is-invalid" : "")}
                            name="departement"
                        >
                            <option value={""} disabled selected>Département</option>
                            {
                                departments.map((dep) => (
                                    <option key={"dep" + dep.id} value={dep.id}>{dep.title}</option>
                                ))
                            }
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className='col-md-6'>
                        <FormControlLabel
                            label="Manager"
                            control={
                                <Checkbox
                                    checked={is_manager}
                                    onChange={(e) => setis_manager(e.target.checked)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />
                            } />
                    </Form.Group>
                </Row>
                <Row className="mb-12">

                    <Form.Group className="col-md-6">
                        <label>cnss</label>
                        <Form.Control
                            required
                            autoComplete="new-password"
                            type="text"
                            placeholder="cnss *"
                            value={cnss}
                            onChange={e => { setcnss(e.target.value) }}
                            className={errorText && cnss === "" ? "is-invalid" : ""}
                        />
                    </Form.Group>

                    <Form.Group className="col-md-6">
                        <label>Téléphone</label>
                        <Form.Control
                            required
                            autoComplete="new-password"
                            type="text"
                            placeholder="Téléphone *"
                            value={tele}
                            onChange={e => { setTele(e.target.value) }}
                            className={errorText && tele === "" ? "is-invalid" : ""}
                        />
                    </Form.Group>

                    <Form.Group className="col-md-6">
                        <label>Pays</label>
                        <Form.Control
                            required
                            autoComplete="new-password"
                            type="text"
                            placeholder="Pays*"
                            value={country}
                            onChange={e => { setcountry(e.target.value) }}
                            className={errorText && country === "" ? "is-invalid" : ""}
                        />
                    </Form.Group>

                    <Form.Group className="col-md-6">
                        <label>Ville</label>
                        <Form.Control
                            required
                            autoComplete="new-password"
                            type="text"
                            placeholder="Ville *"
                            value={city}
                            onChange={e => { setcity(e.target.value) }}
                            className={errorText && city === "" ? "is-invalid" : ""}
                        />
                    </Form.Group>

                    <Form.Group className="col-md-6">
                        <label>address</label>
                        <Form.Control
                            required
                            autoComplete="new-password"
                            type="text"
                            placeholder="address *"
                            value={address}
                            onChange={e => { setaddress(e.target.value) }}
                            className={errorText && address === "" ? "is-invalid" : ""}
                        />
                    </Form.Group>

                    <Form.Group className="col-md-6">
                        <label>Code postal</label>
                        <Form.Control
                            required
                            autoComplete="new-password"
                            type="text"
                            placeholder="Code postal *"
                            value={postcode}
                            onChange={e => { setpostcode(e.target.value) }}
                            className={errorText && postcode === "" ? "is-invalid" : ""}
                        />
                    </Form.Group>


                    <Form.Group className="col-md-6">
                        <label>Signature</label>
                        <input style={{ display: "none", marginTop: "12px" }} accept=".jpg,.png,.jpeg" name="profil_img" id="profil_img" multiple type="file" onChange={(e) => upload_user_signature(e.target.files[0])} />
                        <label htmlFor="profil_img">
                            <span className="submit_but edit_but"  >
                                <EditIcon className="my_icon" /> Importer la signature
                            </span>
                            {signature_file != null ? "(Fichier importé)" : ""}
                        </label>
                    </Form.Group>

                    <Form.Group className='col-md-6'>
                        <FormControlLabel
                            label="Notifier l'utilisateur"
                            control={
                                <Checkbox
                                    checked={notify_user}
                                    onChange={(e) => setnotify_user(e.target.checked)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />
                            } />
                    </Form.Group>

                </Row>
                <Row style={{ display: 'flex', justifyContent: "flex-end" }}>
                    <Button variant="contained" startIcon={<AddIcon />} className={wait_submitting ? "submit_but disabled_button" : "submit_but"} onClick={submit}>
                        Ajouter
                    </Button>
                </Row>

            </div>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={wait_submitting}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );

}

export default Add_services
